/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Remind_BodyInputs */

const en_portal_remind_body = /** @type {(inputs: Portal_Remind_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each morning you get an email or a text with a summary of your day: the session, the plan and the meals. The day before a session, we remind you you're seeing your coach.`)
};

const pl_portal_remind_body = /** @type {(inputs: Portal_Remind_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rano dostajesz e-mail albo SMS z podsumowaniem dnia: trening, plan i posiłki. Dzień przed treningiem przypominamy, że widzisz się z trenerem.`)
};

/**
* | output |
* | --- |
* | "Each morning you get an email or a text with a summary of your day: the session, the plan and the meals. The day before a session, we remind you you're seein..." |
*
* @param {Portal_Remind_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_body = /** @type {((inputs?: Portal_Remind_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_body(inputs)
	return en_portal_remind_body(inputs)
});